import { StatisticsCardProps } from './dashboard-statistics-card.models';

export const STATISTICS_CARD_SVG_ICONS = {
  EXERCISE: 'exercise',
  WORKOUTS: 'workouts',
  JOINTS: 'joints',
  EQUIPMENT: 'equipment',
  LEVELS: 'levels',
} as const;

export const STATISTICS_CARD_PROPS_DEFAULT: StatisticsCardProps[] = [
  {
    title: 'Exercises',
    value: 0,
    icon: 'exercise',
  },
  {
    title: 'Workouts',
    value: 0,
    icon: 'workouts',
  },
  {
    title: 'Joints',
    value: 12,
    icon: 'joints',
  },
  {
    title: 'Equipment',
    value: 9,
    icon: 'equipment',
  },
  {
    title: 'Levels',
    value: 4,
    icon: 'levels',
  },
];
